import { withJsonFormsControlProps } from '@jsonforms/react';
import { Time } from './Time';

const TimeControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <Time
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(TimeControl);
